'use client';

import { Building2 } from 'lucide-react';
import { useHoverTip } from '@/components/layout/HoverTip';
import { UnidadPendingBadgeGate } from '../UnidadPendingBadgeGate';
import sidebarStyles from '../sidebar/sidebar.module.css';
import { tarjetaDeUnidad, textoOcultoDeUnidad, type UnidadAfiliada } from './afiliacion';
import styles from './afiliacion.module.css';

interface AfiliacionFilaProps {
	unidad: UnidadAfiliada;
	idInvestigador?: number;
}

// Fila de una unidad: UNA línea (icono + nombre con elipsis), el mismo patrón de las filas
// de "Líneas de investigación" (`sidebarStyles.lineRow`). El nombre completo, el tipo (Principal / Adicional) y la facultad salen
// en la tarjeta de la app (`HoverTip`) al pasar el mouse, al enfocar la fila con Tab (Escape la cierra) o al
// tocarla (`touch`: un toque en otro lado la cierra; se ve en todos los anchos). Lo mismo, como `sr-only` dentro
// de la fila, queda en el HTML servido: la tarjeta sólo existe mientras hay hover, foco o toque, y un rastreador no
// pasa el mouse (regla de SEO del repo).
export function AfiliacionFila({ unidad, idInvestigador }: AfiliacionFilaProps) {
	const hoverTip = useHoverTip(tarjetaDeUnidad(unidad), 'right', { touch: true });

	return (
		<li
			className={[sidebarStyles.lineRow, unidad.principal ? styles.principal : ''].filter(Boolean).join(' ')}
			tabIndex={0}
			{...hoverTip.handlers}
		>
			<span className={sidebarStyles.lineRowIconBox}>
				<Building2 size={16} className={sidebarStyles.lineRowIcon} aria-hidden="true" />
			</span>
			<span className={styles.nombre}>{unidad.nombre}</span>
			{unidad.principal && <UnidadPendingBadgeGate idInvestigador={idInvestigador} />}
			<span className="sr-only">{textoOcultoDeUnidad(unidad)}</span>
			{hoverTip.tip}
		</li>
	);
}
